import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import theme from './theme';
// Font Awesome. The app renders hundreds of <i className="fas fa-*" /> icons
// (admin menu, stat cards, action buttons, ...) but nothing ever loaded the
// stylesheet that defines them, so every one rendered as an empty element and
// icon-only buttons looked like blank squares. Self-hosted rather than pulled
// from a CDN so the icons still work offline inside the Capacitor app.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import { initSafeAreaInsets } from './utils/safeAreaInsets';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Android's WebView never reports the status bar through env(safe-area-inset-*).
// This copies the real insets, measured natively, into the --safe-area-* custom
// properties. No-op on iOS and in browsers, where env() already works.
initSafeAreaInsets();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </ErrorBoundary>
);

// Register service worker for PWA functionality (disabled in development)
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  // Unregister any existing service worker in development
  serviceWorkerRegistration.unregister();
}
